// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.survey-list-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px;
}
.survey-list-wrapper .survey-list-container {
  margin: 0 auto;
  max-width: 570px;
  width: 100%;
  padding: 40px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.survey-list-wrapper .survey-list-container .survey-list-item {
  text-align: left;
  width: 100%;
  font-size: 14px;
  border-radius: 5px;
  padding: 14px 25px;
  border: none;
  font-weight: 500;
  background-color: #FFFFFF;
  color: #000000;
  cursor: pointer;
}
.survey-list-wrapper .survey-list-container .survey-list-item:disabled {
  opacity: 0.25;
  pointer-events: none;
}
.survey-list-wrapper .survey-list-container .survey-list-item:hover {
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.05);
}

.user-toast {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translate(-50%, 0);
  background-color: #FFFFFF;
  padding: 10px 30px;
  border-radius: 20px;
  display: flex;
  flex-direction: row;
  gap: 20px;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.05);
  animation: 0.5s ease-out 0s 1 slideInFromTop;
}
.user-toast span {
  color: #000000;
  font-size: 14px;
}
.user-toast button {
  border: none;
  outline: none;
  background-color: transparent;
  text-decoration: underline;
  font-weight: bold;
  cursor: pointer;
}

@keyframes slideInFromTop {
  0% {
    transform: translate(-50%, -100%);
  }
  100% {
    transform: translate(-50%, 0);
  }
}`, "",{"version":3,"sources":["webpack://./src/views/list/style.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AACF;AACE;EACE,cAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACJ;AACI;EACE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;AACN;AACM;EACE,aAAA;EACA,oBAAA;AACR;AAEM;EACE,2CAAA;AAAR;;AAQA;EACE,eAAA;EACA,SAAA;EACA,SAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,2CAAA;EAEA,4CAAA;AANF;AAQE;EACE,cAAA;EACA,eAAA;AANJ;AASE;EACE,YAAA;EACA,aAAA;EACA,6BAAA;EACA,0BAAA;EACA,iBAAA;EACA,eAAA;AAPJ;;AAWA;EACE;IACE,iCAAA;EARF;EAUA;IACE,6BAAA;EARF;AACF","sourcesContent":[".survey-list-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 48px;\r\n\r\n  .survey-list-container {\r\n    margin: 0 auto;\r\n    max-width: 570px;\r\n    width: 100%;\r\n    padding: 40px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n\r\n    .survey-list-item {\r\n      text-align: left;\r\n      width: 100%;\r\n      font-size: 14px;\r\n      border-radius: 5px;\r\n      padding: 14px 25px;\r\n      border: none;\r\n      font-weight: 500;\r\n      background-color: #FFFFFF;\r\n      color: #000000;\r\n      cursor: pointer;\r\n\r\n      &:disabled {\r\n        opacity: 0.25;\r\n        pointer-events: none;\r\n      }\r\n\r\n      &:hover {\r\n        box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.05);\r\n      }\r\n    }\r\n\r\n  }\r\n\r\n}\r\n\r\n.user-toast {\r\n  position: fixed;\r\n  top: 20px;\r\n  left: 50%;\r\n  transform: translate(-50%, 0);\r\n  background-color: #FFFFFF;\r\n  padding: 10px 30px;\r\n  border-radius: 20px;\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 20px;\r\n  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.05);\r\n  //transition: transform 0.4s cubic-bezier(.25, .8, .25, 1)''\r\n  animation: 0.5s ease-out 0s 1 slideInFromTop;\r\n\r\n  span {\r\n    color: #000000;\r\n    font-size: 14px;\r\n  }\r\n\r\n  button {\r\n    border: none;\r\n    outline: none;\r\n    background-color: transparent;\r\n    text-decoration: underline;\r\n    font-weight: bold;\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n@keyframes slideInFromTop {\r\n  0% {\r\n    transform: translate(-50%, -100%);\r\n  }\r\n  100% {\r\n    transform: translate(-50%, 0);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
